import { useEffect } from 'react';
import { prefetchFor } from '../routePrefetch';

/**
 * LinkPrefetcher - mounted once, listens globally for hover/touch on any
 * internal link and warms that route's chunk. No changes needed to the
 * individual <Link>s. Fully passive and degrades to a no-op for routes
 * that are not in the prefetch registry.
 */
const LinkPrefetcher = () => {
  useEffect(() => {
    let lastPath = null;

    const handle = (e) => {
      const target = e.target;
      if (!target || !target.closest) return;
      const a = target.closest('a[href^="/"]');
      if (!a) return;
      try {
        const url = new URL(a.href, window.location.origin);
        // Same-origin internal links only, and avoid re-firing for the
        // path we just warmed.
        if (url.origin !== window.location.origin) return;
        if (url.pathname === lastPath) return;
        lastPath = url.pathname;
        prefetchFor(url.pathname);
      } catch { /* ignore malformed hrefs */ }
    };

    document.addEventListener('mouseover', handle, { passive: true });
    document.addEventListener('touchstart', handle, { passive: true });
    return () => {
      document.removeEventListener('mouseover', handle);
      document.removeEventListener('touchstart', handle);
    };
  }, []);

  return null;
};

export default LinkPrefetcher;
